import { render, staticRenderFns } from "./otherStream.vue?vue&type=template&id=31e74ce6"
import script from "./otherStream.vue?vue&type=script&lang=js"
export * from "./otherStream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports